import React, {useEffect} from "react";
import {observer} from "mobx-react-lite";

import appStore from "../../../storage/AppStore";
import clubStore from "../../../storage/ClubStore";

import MultipleSelect from "../../../ui/MultipleSelect";


const MemberTeam = () => {

    useEffect(() => {
        const companyId =
            clubStore.club.id;

        if (!companyId) {
            return;
        }

        if (
            clubStore.teamQuery.parent_id !==
            companyId
        ) {
            clubStore.teamQuery.setProperty(
                "parent_id",
                companyId
            );
        }

        clubStore.getTeams();

    }, [clubStore.club.id]);


    return (
        <div className="col-12">

            <label
                htmlFor="input_member_teams"
                className="block mb-1"
            >
                {appStore.tr.teams}
            </label>


            <MultipleSelect
                inputId="input_member_teams"

                store={clubStore.member}

                prop="teams"

                options={
                    clubStore.teams || []
                }

                label={
                    appStore.tr.teams
                }
            />

        </div>
    );
};


export default observer(
    MemberTeam
);